import { Injectable } from '@angular/core';
import { CoreService } from 'src/app/core/services/core.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TableGridHeader } from './../../../shared/components/table-grid/table-grid.model';
import { ReportingCycleDetails } from './../../../shared/models/reportingcycle.model';
import {
  SymbolValidator,
  TextValidator,
} from 'src/app/shared/validators/textPatternValidator';
import { Observable } from 'rxjs';
import {
  CREATE_REPORTING_CYCLE,
  GET_COMMENTS,
  GET_REPORTING_CYCLE,
} from 'src/app/shared/constants/user-api-constants';
import { map } from 'rxjs/operators';
import { ReportingCycleService } from 'src/app/shared/service/reporting-cycle.service';
@Injectable({
  providedIn: 'root',
})
export class ManageReportingService {
  constructor(
    private coreService: CoreService,
    private reportingCycleService: ReportingCycleService,
  ) {}

  public getCurrentReportingCycleData(): Observable<any> {
    return this.reportingCycleService.getDetails().pipe(
      map((reportingCycles: ReportingCycleDetails[]) => {
        // enrich
        reportingCycles.forEach((reportingCycle: ReportingCycleDetails) => {
          // name
          reportingCycle.reportingCycleYearName =
            this.coreService.getDropdownValueByID(
              reportingCycle.reportingCycleCode,
            );

          //id
          reportingCycle.reportingCycleID = reportingCycle.id;
        });

        return reportingCycles;
      }),
    );
  }

  public getCurrentReportingCycleDataByID(id: number): Observable<any> {
    return this.reportingCycleService.getDetail(id).pipe(
      map((previousReportingCycles: ReportingCycleDetails[]) => {
        previousReportingCycles.forEach(
          (previousReportingCycle: ReportingCycleDetails) => {
            previousReportingCycle.reportingCycleYearName =
              this.coreService.getDropdownValueByID(
                previousReportingCycle.reportingCycleCode,
              );
            // previousReportingCycle.baseReportingCycleName = this.coreService.getDropdownValueByID(
            //   previousReportingCycle.baseReportingCycleCode
            // );
            previousReportingCycle.reportingCycleID = previousReportingCycle.id;
          },
        );
        return previousReportingCycles[0];
      }),
    );
  }

  public getCurrentReportingCycleHeaders(): TableGridHeader[] {
    return [
      {
        name: 'Title',
        key: 'title',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'year',
        key: 'reportingCycleYearName',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'description',
        key: 'description',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'baseline Reporting cycle',
        key: 'baseReportingCycleCode',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'Publish Date',
        key: 'creationDate',
        sortType: 'date',
        type: 'date',
      },
      {
        name: '',
        key: '',
        sortType: '',
        type: 'lock-detail-button',
      },
    ];
  }

  public getPreviousReportingCycleHeaders(): TableGridHeader[] {
    return [
      {
        name: 'Title',
        key: 'title',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'year',
        key: 'reportingCycleYearName',
        sortType: 'string',
        sort: 'desc',
        type: 'string',
      },
      {
        name: 'description',
        key: 'description',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'baseline Reporting cycle',
        key: 'baseReportingCycleCode',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'Publish Date',
        key: 'creationDate',
        sortType: 'date',
        type: 'date',
      },
      {
        name: '',
        key: '',
        sortType: '',
        type: 'detail-button',
      },
    ];
  }

  // get reportingCycle form
  public getCreateReportingFormControls(
    reportingCycleData?: ReportingCycleDetails,
  ): FormGroup {
    const title =
      reportingCycleData && reportingCycleData.title
        ? { value: reportingCycleData.title, disabled: true }
        : null;
    const reportingCycleCode =
      reportingCycleData && reportingCycleData.reportingCycleCode
        ? { value: reportingCycleData.reportingCycleCode, disabled: true }
        : null;
    const baseReportingCycleCode =
      reportingCycleData && reportingCycleData.baseReportingCycleCode
        ? { value: reportingCycleData.baseReportingCycleCode, disabled: true }
        : null;
    const description =
      reportingCycleData && reportingCycleData.description
        ? { value: reportingCycleData.description, disabled: true }
        : null;
    return new FormGroup({
      id: new FormControl(reportingCycleData ? reportingCycleData.id : null),
      title: new FormControl(title, [
        Validators.required,
        TextValidator(100),
        SymbolValidator(),
      ]),
      reportingCycleCode: new FormControl(reportingCycleCode, [
        Validators.required,
      ]),
      baseReportingCycleCode: new FormControl(baseReportingCycleCode, [
        Validators.required,
      ]),
      description: new FormControl(description, [
        Validators.required,
        Validators.maxLength(300),
      ]),

      isLocked: new FormControl(
        reportingCycleData ? reportingCycleData.isLocked : null,
      ),
      isActive: new FormControl(
        reportingCycleData ? reportingCycleData.isActive : null,
      ),
    });
  }
}
